import { CategoriesState } from './state';

export const categoriesInitial: CategoriesState = {
  categoriesList: [],
};
